import type { Form, FormSection, FormTable, FormUploadButton } from '../../interfaces/form.interface';
import { FormType } from '../../interfaces/form.interface';

export interface ReactiveModalFormCoordinatorConfig<TModel> {
    readonly name: string;
    readonly header: string;
    readonly type: FormType;
    readonly sections: FormSection<TModel>[];
    readonly table?: FormTable | null;
    readonly uploadButton?: FormUploadButton;
    readonly signed?: boolean;
}


/** Creates modal form definitions with the same defaults used by legacy list modals. */
export class ReactiveModalFormCoordinator {
    public static createForm<TModel>(config: ReactiveModalFormCoordinatorConfig<TModel>): Form<TModel> {
        return {
            name: config.name,
            header: config.header,
            type: config.type,
            sections: config.sections,
            table: config.table ?? null,
            uploadButton: config.uploadButton ?? { isEnabled: false, label: '' },
            signed: config.signed ?? false,
        };
    }
}
